import { createApiHook, useApi } from "../utils/apiUtils";

const useDeleteQuestionnaire = () => {
  const { apiDelete } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const deleteQuestionnaire = async (id) => {
    startLoading();
    const res = await apiDelete(`/questionnaires/${id}/delete_with_survey`, "Error al eliminar el cuestionario");

    setResponse(res);

    if (res?.error) {
      const err = new Error(res.error.message || "No se pudo eliminar el cuestionario");
      err.backend = res.error;
      throw err;
    }

    return res;
  };

  return { deleteQuestionnaire, data, loading, error };
};

export default useDeleteQuestionnaire;
